export class SelectOption {
  value?: string;
  key?: string;
  constructor(key: any, value: any) {
    this.key = key;
    this.value = value;
  }
  static getDistinct(options: SelectOption[]) {
    if (options?.length == 1) {
      return options;
    }
    return options?.reduce((opts: SelectOption[], current) => {
      const found = opts.some((opt) => opt.key == current.key);
      if (!found) {
        opts.push(current);
      }
      return opts;
    }, []);
  }

  // toString() {
  //   return this.key + '-' + this.value;
  // }
}
